import { APP_VERSION, APP_UPDATED } from "../../constants/version";
import { DEMO_MODE } from "../../utils/firebase";

export function VersionTag({ style = {} }) {
  return <div style={{ fontSize: ".68rem", color: "var(--muted)", fontWeight: 600, ...style }}>v{APP_VERSION} · {APP_UPDATED}{DEMO_MODE ? " · Local Mode" : " · Firebase"}</div>;
}
